

export function GetClashBotData(allCastingData, allProjectData, auditionees, season) {

  console.log(allCastingData);
  console.log(auditionees);

  var clashBotData = [];

  const filterProject = (x) => {return x.season === season}
  const filteredProjectData = allProjectData.filter(filterProject);
  const filteredProjectIds = filteredProjectData.map((p) => { return p.uid });
  const filterCasting = (x) => {return filteredProjectIds.includes(x.uid)}
  const filteredCastingData = allCastingData.filter(filterCasting);

  filteredCastingData.forEach((castingData) => {
    
    // Get the project's relevant project data
    var projectData = null;
    filteredProjectData.every((p) => {
      if(castingData.uid === p.uid) {
        projectData = p;
        return false;
      }
      else return true;
    })

    // Add the choices for each role
    const newRoles = []
    castingData.roles.forEach((role) => {

      const newRole = {
        name: role.name,
        choices: []
      };

      // All auditionee's IDs are replaced with their index in the merged auditionees list, for easy accessing
      role.choices.forEach((choice, i) => {
        if(choice === '' || choice === null) newRole.choices.push(null);
        else if(choice !== null)
        {
          auditionees.every((auditionee, j) => {
            if(auditionee.uids.includes(choice)) {
              newRole.choices.push(j);
              return false;
            }
            else return true;

          })
        }
      })

      newRoles.push(newRole);
    })

    clashBotData.push(
      {
        name: projectData.name,
        week: projectData.week,
        project_type: projectData.project_type,
        roles: newRoles
      }
    )

  })

  return clashBotData;
}